import {
    defaultColumnsVisibility,
    defaultColumnsSizing,
    paramColumnToColumnKey,
    defaultColumnsOrder,
} from '@/store/well-logs/tabletSettings/config';
import { restoreCurveSettingsObj } from './prepareStateWellColumns';
/*
    Сброс видимости колонок в значение false
*/
const resetColumnsVisibility = columns => {
    const columnKeys = Object.keys(columns);
    const result = {};

    for (const columnKey of columnKeys) {
        result[columnKey] = false;
    }

    return result;
};

const getColumnsOrder = columnsOrder => {
    if (columnsOrder) {
        const restColumns = defaultColumnsOrder.filter(key => !columnsOrder.find(tKey => tKey === key));
        return [...columnsOrder, ...restColumns];
    }
    return defaultColumnsOrder;
};

const rigisColumnsArray = ['geoObjects', 'lithology', 'thicknessInterlayer', 'paramsHistogram'];

/*
    Формирование части настроек (видимость и размер) планшета согласно значения из сущности "Состояние скважины"
*/
export const getSettingsFromStateWell = (stateWell, defaultSettings, rootState) => {
    const { inspector, tablets } = rootState;
    const { params: stateWellParams } = stateWell;
    const visibility = resetColumnsVisibility(defaultColumnsVisibility);
    const sizes = { ...defaultColumnsSizing };
    const geoObjecstStrParamNalue = stateWellParams.filter(param => param.paramTitle === 'Пласт')[0].strParamValue;
    let parsedColumnsOrder = geoObjecstStrParamNalue ? JSON.parse(geoObjecstStrParamNalue)?.columnsOrder : [];
    let geoVersions,
        rigisColumnsOrder,
        rigisParamsHistogramIds,
        fgiParamsHistogramIds = [];
    let rigisColumnsCount = 3;
    if (geoObjecstStrParamNalue) {
        for (const param of stateWellParams) {
            const columnKey = paramColumnToColumnKey[param.paramColumn];

            const { paramWidth, intParamValue, paramType, strParamValue } = param;

            if (!columnKey) continue;

            if (columnKey === 'geoObjects' && strParamValue) {
                const parsedSettings = JSON.parse(strParamValue);
                visibility[columnKey] = parsedSettings.visible === '1' ? true : false;
                geoVersions = parsedSettings.versions;
                rigisColumnsCount = parsedSettings.rigisColumnsCount ?? defaultSettings.rigisColumnsCount;
                rigisColumnsOrder = parsedSettings.rigisColumnsOrder ?? defaultSettings.rigisColumnsOrder;
                rigisParamsHistogramIds =
                    parsedSettings.rigisParamsHistogramIds ?? defaultSettings.rigisParamsHistogramIds;
                fgiParamsHistogramIds = parsedSettings.fgiParamsHistogramIds ?? defaultSettings.fgiParamsHistogramIds;
            }
            if (columnKey === 'carrotage') {
                visibility[columnKey] = intParamValue && intParamValue === 2 ? true : false;
            }
            if (columnKey !== 'carrotage' && columnKey !== 'geoObjects')
                visibility[columnKey] = strParamValue && strParamValue === '1' ? true : false;
            if (columnKey) {
                const { minWidth } = sizes[columnKey];
                sizes[columnKey] = {
                    ...sizes[columnKey],
                    width: Math.max(minWidth, paramWidth),
                    widthType: 'PIXEL',
                };
            }
        }
    } else {
        rigisColumnsCount = 0;
        parsedColumnsOrder = defaultColumnsOrder;
        let insertedAllGeoObjects = false;
        if (inspector.geoObjects[tablets.activeGroupName]?.length > 0) {
            geoVersions = inspector.geoObjects[tablets.activeGroupName].map(item => ({
                id: item.stratumVersionId,
                visible: item.visible,
            }));
        }
        for (const param of stateWellParams) {
            let columnKey = paramColumnToColumnKey[param.paramColumn];
            if (param.paramColumn === 4) columnKey = 'lithology'; // Раньше колонка Литология/Насыщение имела занчение 4, сейчас 3.

            if (!columnKey) continue;

            if (!insertedAllGeoObjects && rigisColumnsArray.includes(columnKey)) {
                let geoIndex = parsedColumnsOrder.indexOf(columnKey);
                const allGeoIndex = parsedColumnsOrder.indexOf('allGeoObjects');

                if (geoIndex !== -1) {
                    if (allGeoIndex !== -1) {
                        parsedColumnsOrder.splice(allGeoIndex, 1);

                        if (allGeoIndex < geoIndex) {
                            geoIndex--;
                        }
                    }

                    parsedColumnsOrder.splice(geoIndex, 0, 'allGeoObjects');
                    insertedAllGeoObjects = true;
                }
            }

            if (
                columnKey === 'geoObjects' ||
                columnKey === 'lithology' ||
                columnKey === 'thicknessInterlayer' ||
                columnKey === 'paramsHistogram'
            ) {
                visibility.allGeoObjects = true;
                rigisColumnsCount++;
            }
            visibility[columnKey] = true;

            {
                const { paramWidth } = param;
                const { minWidth } = sizes[columnKey];

                sizes[columnKey] = {
                    ...sizes[columnKey],
                    width: Math.max(minWidth, paramWidth),
                    widthType: 'PIXEL',
                };
            }
        }
    }

    return {
        columnsOrder: getColumnsOrder(parsedColumnsOrder),
        geoVersions: geoVersions,
        columnsVisibility: visibility,
        columnsSizing: sizes,
        fgiParamsHistogramIds: fgiParamsHistogramIds,
        rigisParamsHistogramIds: rigisParamsHistogramIds,
        rigisColumnsCount: rigisColumnsCount,
        rigisColumnsOrder: rigisColumnsOrder ?? defaultSettings.rigisColumnsOrder,
    };
};

export const restoreCurvesSettings = well => {
    const paramsWithoutGis = well.params.filter(param => param.paramColumn !== 7);
    const gisParamsNotGrouped = well.params.filter(param => param.paramColumn === 7);

    let paramIndexShift = 0;

    const augmentedParams = [];

    for (let i = 0; i < gisParamsNotGrouped.length; i++) {
        const originalItem = gisParamsNotGrouped[i];
        const item = {
            ...originalItem,
            paramIndex: (originalItem.paramIndex ?? 0) + paramIndexShift,
        };

        const childrenToAdd = [];

        let strParamValueObj = null;
        if (item?.strParamValue?.includes('curveSettings') || item?.strParamValue?.includes('curveDisplaySettings')) {
            strParamValueObj = restoreCurveSettingsObj(item.strParamValue);
        }

        const children = strParamValueObj?.curveDisplaySettings?.childrenCurves ?? [];
        if (children.length > 0) {
            for (let j = 0; j < children.length; j++) {
                const childCurve = children[j];

                strParamValueObj.curveDisplaySettings.scaleProps = {
                    xStart: childCurve.xStart,
                    xStep: childCurve.xStep,
                    xStop: childCurve.xStop,
                };
                strParamValueObj.curveDisplaySettings.childrenCurves = null;

                childrenToAdd.push({
                    ...item,
                    intParamValue: item.intParamValue,
                    paramTitle: item.paramTitle,
                    paramNumber: childCurve.curve,
                    paramIndex: item.paramIndex + paramIndexShift + j + 1,
                    strParamValue: strParamValueObj,
                });
            }
            paramIndexShift += children.length;
        }

        augmentedParams.push(item, ...childrenToAdd);
    }

    const gisParamsGrouped = augmentedParams.reduce(
        (acc, item) => {
            if (
                typeof item?.strParamValue === 'string' &&
                (item?.strParamValue?.includes('curveSettings') ||
                    item?.strParamValue?.includes('curveDisplaySettings'))
            ) {
                const strParamValueObj = restoreCurveSettingsObj(item.strParamValue);
                item.strParamValue = strParamValueObj;
            }

            return {
                intParamValue: item.intParamValue,
                paramColumn: 7,
                paramIndex: item?.paramIndex,
                paramTitle: item?.paramTitle,
                paramWidth: Math.max(acc.paramWidth, item?.paramWidth ?? 0),
                paramType: item?.paramType,
                children: [
                    ...acc.children,
                    {
                        paramNumber: item?.intParamValue,
                        strParamValue: item.strParamValue,
                        param: item?.paramNumber,
                        curveSettings: item.strParamValue?.curveSettings,
                        curveDisplaySettings: item.strParamValue?.curveDisplaySettings,
                    },
                ],
            };
        },
        { children: [], paramWidth: 0 },
    );

    return [...paramsWithoutGis, gisParamsGrouped];
};
